import { jsx as _jsx } from "react/jsx-runtime";
import { useFormikContext } from 'formik';
import lodashGet from 'lodash/get';
import { forwardRef } from 'react';
import Input from '../Input';
const FormikInput = forwardRef(function FormikInput(props, ref) {
    const { name, style = { label: {}, input: {}, inputWrapper: {} }, onChange, type = 'text', className = '', value = null, checkErrorAfterInputTouched = true, mapOnChangeValue, mapValue, ...resProps } = props;
    const { values, handleChange, errors, touched, setFieldValue, handleBlur } = useFormikContext();
    function changeHandler(e) {
        onChange?.(e);
        if (mapOnChangeValue) {
            void setFieldValue(name, mapOnChangeValue(e.target.value));
        }
        else {
            handleChange(e);
        }
    }
    let isInvalid = lodashGet(errors, name);
    if (checkErrorAfterInputTouched) {
        isInvalid = lodashGet(errors, name) && lodashGet(touched, name);
    }
    let val = value || lodashGet(values, name);
    val = mapValue ? mapValue(val) : val;
    return (_jsx(Input, { ref: ref, name: name, value: val, onChange: changeHandler, onBlur: handleBlur, type: type, style: {
            ...style,
            inputWrapper: {
                ...style.inputWrapper,
                ...(isInvalid
                    ? {
                        borderColor: 'red',
                        borderWidth: '1px',
                        borderStyle: 'solid',
                        outline: 'none',
                    }
                    : {}),
            },
        }, className: className, ...resProps }));
});
export default FormikInput;
